import React from "react";
import { useToggle } from "hooks";
import FormBar from "@hs/form-bar";
import { useFormActions } from "hooks";
import { FormBarView } from "data/types";
import { getClassNames, getLocalizedText } from "data/utils";
import styles from "./Relations.module.css";

type Props = {
    className?: string,
};

const components = {
    Container: "aside",
};

/**
 * renders dismissable workflow info
 *
 * @param {Props} { className }
 */
export const Relations = ({ className }: Props) => {
    const [show, toggleShow] = useToggle(true);
    const actions = useFormActions(FormBarView.Relations);
    return (
        <FormBar
            className={getClassNames(
                className,
                styles.aside,
                show ? styles.show : styles.hide
            )}
            onClose={toggleShow}
            actions={actions}
            components={components}
        >
            <div className={styles.wrapper}>
                <span>{getLocalizedText("$formActions:relations.any")}</span>
            </div>
        </FormBar>
    );
};
Relations.displayName = "FormBar.Relations";
export default Relations;
